import React from "react";
import BadgeTooltip from "./BadgeTooltip";

const IssuesBadge = ({ issues }) => {
  if (!issues || !issues.length) return null;

  const trigger = (
    <div className="code_badge__container">
      <div className="code_badge__indicator" />
      <div className="t--sm">{issues.length}</div>
    </div>
  );

  return (
    <BadgeTooltip trigger={trigger} rowCount={Math.min(issues.length, 5)}>
      {issues.map((code) => (
        <div key={code} className="flex align-items-center gap--4">
          <div className="code_badge__indicator" />
          <div className="t--md">{code}</div>
        </div>
      ))}
    </BadgeTooltip>
  );
};

export default IssuesBadge;
